module.exports = __webpack_public_path__ + "img/icone-QUANTO-MAIS-VIDEO-MELHOR.a0f81118.png";